import { useEffect, useState } from 'react'
import { useWindowSize } from './use.window.size'

export const useEditorSize = () => {
  const { width, height } = useWindowSize()

  const calculate = (width: number, height: number) => {
    return {
      editor: width > 800 ? Math.min(600, width * 0.5) : width - 36,
      height,
      helper: 600,
      visible: {
        editor: true,
        helper: width > 800,
      },
      width,
    }
  }

  const [size, setSize] = useState(calculate(width, height))

  useEffect(() => {
    const calculated = calculate(width, height)

    if (size.width !== calculated.width || size.height !== calculated.height) {
      setSize(calculate(width, height))
    }
  }, [width, height])

  return size
}
